// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"m_bs ml-3","matrix-table--pad4":"m_bt ml-5","matrix-table__title":"m_bv","matrix-table__true":"m_bw","matrix-table__false":"m_bx"};